<form (ngSubmit)="submit(true)" [formGroup]="form" class="flex flex-col gap-4">
  <h3>{{ isEditMode ? 'Editar proveedor' : 'Alta de proveedores' }}</h3>

  <input (change)="handleLogoSelected($event)" accept="image/*" class="hidden" id="supplier-logo-input" type="file">
  <input (change)="handleDocumentsSelected($event)" accept=".pdf,.doc,.docx,.png,.jpg,.jpeg" class="hidden" id="supplier-documents-input" multiple type="file">
  <button (click)="openLogoPicker()" [disabled]="isLoadingDetail || isSubmitting" class="btn btn-neutral-outline avatar !w-[3rem] !h-[3rem] overflow-hidden" type="button">
    @if (logoSrc()) {
      <img [src]="logoSrc()" alt="Logo del proveedor" class="h-full w-full object-cover">
    }
  </button>

  @if (isLoadingDetail) {
    <div class="flex flex-col gap-4">
      <div class="h-11 skeleton skeleton-rect rounded-xl"></div>
      <div class="flex lg:flex-row gap-2">
        <div class="h-11 skeleton skeleton-rect rounded-xl flex-1/2"></div>
        <div class="h-11 skeleton skeleton-rect rounded-xl flex-1/2"></div>
      </div>
      <div class="flex lg:flex-row gap-2">
        <div class="h-11 skeleton skeleton-rect rounded-xl flex-1/2"></div>
        <div class="h-11 skeleton skeleton-rect rounded-xl flex-1/2"></div>
      </div>
      <div class="h-11 skeleton skeleton-rect rounded-xl"></div>
      <div class="h-20 skeleton skeleton-rect rounded-xl"></div>
      <div class="h-20 skeleton skeleton-rect rounded-xl"></div>
      <div class="h-20 skeleton skeleton-rect rounded-xl"></div>
    </div>
  } @else {

  <div class="form-control">
    <label class="text-neutral-900" for="name">Denominador social</label>
    <div class="input-icon">
      <input autocomplete="off" formControlName="name" id="name" placeholder="Por ejemplo: Cafe Candelas S.L." type="text">
    </div>
  </div>

  <div class="flex lg:flex-row gap-2">
    <div class="form-control flex-1/2">
      <label class="text-neutral-900" for="taxId">CIF</label>
      <div class="input-icon">
        <input autocomplete="off" formControlName="taxId" id="taxId" placeholder="Ej: 123456789L" type="text">
      </div>
    </div>
    <div class="form-control flex-1/2">
      <label class="text-neutral-900" for="phone">Teléfono</label>
      <div class="input-icon">
        <input autocomplete="off" formControlName="phone" id="phone" placeholder="Ej: 666666666" type="text">
      </div>
    </div>
  </div>

  <div class="flex lg:flex-row gap-2">
    <div class="form-control flex-1/2">
      <label class="text-neutral-900" for="email">Email</label>
      <div class="input-icon">
        <input autocomplete="off" formControlName="email" id="email" placeholder="Ej: Admin@cafecandelas.com" type="text">
      </div>
    </div>
    <div class="form-control flex-1/2">
      <label class="text-neutral-900" for="website">Web</label>
      <div class="input-icon">
        <input autocomplete="off" formControlName="website" id="website" placeholder="Ej: cafecandelas.com" type="text">
      </div>
    </div>
  </div>

  <div class="form-control">
    <label class="text-neutral-900" for="contact">Persona de contacto</label>
    <div class="input-icon">
      <input autocomplete="off" formControlName="contact" id="contact" placeholder="Por ejemplo: Alfonso Álvarez Fondón" type="text">
    </div>
  </div>

  <div class="form-control w-full">
    <label class="text-neutral-900" for="basicNeed">¿Aporta una necesidad básica a la empresa?</label>
    <div class="flex flex-row gap-2 w-full">
      <label class="flex flex-row items-center">
        <input formControlName="basicNeed" name="basicNeed" style="width: 1.5rem" type="radio" value="yes">
        <span>Si</span>
      </label>
      <label class="flex flex-row items-center">
        <input formControlName="basicNeed" name="basicNeed" style="width: 1.5rem" type="radio" value="no">
        <span>No</span>
      </label>
      <label class="flex flex-row items-center">
        <input formControlName="basicNeed" name="basicNeed" style="width: 1.5rem" type="radio" value="partial">
        <span>Parcial</span>
      </label>
    </div>
  </div>

  <div class="form-control w-full">
    <label class="text-neutral-900" for="hasChannel">¿Tiene canal de denuncia?</label>
    <div class="flex flex-row gap-2 w-full">
      <label class="flex flex-row items-center">
        <input formControlName="hasChannel" name="hasChannel" style="width: 1.5rem" type="radio" value="yes">
        <span>Si</span>
      </label>
      <label class="flex flex-row items-center">
        <input formControlName="hasChannel" name="hasChannel" style="width: 1.5rem" type="radio" value="no">
        <span>No</span>
      </label>
      <label class="flex flex-row items-center">
        <input formControlName="hasChannel" name="hasChannel" style="width: 1.5rem" type="radio" value="partial">
        <span>Parcial</span>
      </label>
    </div>
  </div>

  <div class="form-control w-full">
    <label class="text-neutral-900" for="compliance">¿Realiza compliance?</label>
    <div class="flex flex-row gap-2 w-full">
      <label class="flex flex-row items-center">
        <input formControlName="compliance" name="compliance" style="width: 1.5rem" type="radio" value="yes">
        <span>Si</span>
      </label>
      <label class="flex flex-row items-center">
        <input formControlName="compliance" name="compliance" style="width: 1.5rem" type="radio" value="no">
        <span>No</span>
      </label>
      <label class="flex flex-row items-center">
        <input formControlName="compliance" name="compliance" style="width: 1.5rem" type="radio" value="partial">
        <span>Parcial</span>
      </label>
    </div>
  </div>

  <div class="form-control w-full">
    <label class="text-neutral-900" for="consolidated">¿Es una empresa consolidada en el mercado</label>
    <div class="flex flex-row gap-2 w-full">
      <label class="flex flex-row items-center">
        <input formControlName="consolidated" name="consolidated" style="width: 1.5rem" type="radio" value="yes">
        <span>Si</span>
      </label>
      <label class="flex flex-row items-center">
        <input formControlName="consolidated" name="consolidated" style="width: 1.5rem" type="radio" value="no">
        <span>No</span>
      </label>
      <label class="flex flex-row items-center">
        <input formControlName="consolidated" name="consolidated" style="width: 1.5rem" type="radio" value="partial">
        <span>Parcial</span>
      </label>
    </div>
  </div>

    <div class="flex flex-col gap-2 w-full">
      <div class="flex flex-row justify-between border-b-1 pb-2">
        <span>Documentación</span>
        <button (click)="openDocumentsPicker()" [disabled]="isSubmitting || isLoadingDetail" class="btn btn-neutral-text !px-1 !py-1" type="button">
          <img alt="Icon" class="filter-neutral-800 h-4" src="/assets/icons/feather/paperclip.svg">
      </button>
    </div>
    <div class="flex flex-col gap-2">
      @for (file of pendingAttachments; track file.name + '-' + file.size + '-' + $index) {
        <core-file-widget
          [fileName]="file.name"
          [fileSize]="formatFileSize(file.size)"
          [showDownload]="false"
          (remove)="removePendingAttachment($index)"/>
      }
      @for (file of existingDocumentationAttachments; track file.id) {
        <core-file-widget
          [fileName]="file.fileName"
          [fileSize]="formatFileSize(file.fileSize)"
          [showRemove]="false"
          (download)="downloadExistingAttachment(file)"/>
      }
      @if (!pendingAttachments.length && !existingDocumentationAttachments.length) {
        <span class="cd-text-b3 text-neutral-500">Sin documentos seleccionados.</span>
      }
    </div>
  </div>

  @if (errorMessage) {
    <span class="cd-text-b4 text-error-600">{{ errorMessage }}</span>
  }

  <div class="w-full flex flex-row items-center gap-4">
    <button [disabled]="isSubmitting || isLoadingDetail" class="btn btn-primary flex flex-row gap-2 items-center min-w-[3rem]" type="submit"
            style="border-radius: 0.5rem;padding: 0.5rem 1rem">
      <img alt="Icon" class="filter-neutral-100 h-4" src="/assets/icons/feather/save.svg">
      <span class="hidden lg:block cd-text-md truncate capitalize">
        {{ isSubmitting ? 'Guardando...' : 'Guardar' }}
      </span>
    </button>

    <button (click)="submit(false)" [disabled]="isSubmitting || isLoadingDetail" class="btn btn-primary-soft flex flex-row gap-2 items-center min-w-[3rem]"
            style="border-radius: 0.5rem;padding: 0.5rem 1rem" type="button">
      <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/plus-square.svg">
      <span class="hidden lg:block cd-text-md truncate capitalize">Guardar y crear otro</span>
    </button>
  </div>
  }
</form>
